var _defs, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "down_svg__icon",
    viewBox: "0 0 1706 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 333.203,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M853.333 754.859L1506.304 82.26a82.773 82.773 0 01118.784 0c33.11 34.134 33.11 88.235 0 122.368L932.523 918.187a87.723 87.723 0 01-18.262 25.6 82.603 82.603 0 01-60.928 23.21 82.603 82.603 0 01-79.189-48.81L81.579 204.8a87.893 87.893 0 011.706-124.075 82.773 82.773 0 01117.078 1.707l652.97 672.256z"
  })));
}
export default SvgDown;